import { hideOverlay, showModalMessage, showOverlay } from 'Modules/store/actions'
import { call, put, takeLatest } from 'redux-saga/effects'
import { FAILURE, REQUEST, SUCCESS } from 'Stores'
import { generateCode, reset2fa, verifyCode, verifyCodeReset } from 'APIs/2fa'
import { push } from 'connected-react-router'
import { setLocalStorage, STORAGE } from 'Utils'
import { SET_IS_2FA } from 'Modules/auth/store/constants'
import { GENERATE_CODE, RESET_2FA, VERIFY_CODE, VERIFY_CODE_RESET } from './constants'

export function* reset2FASaga({ payload }) {
  try {
    yield put(showOverlay())
    yield call(reset2fa, payload)
    yield put(hideOverlay())
    yield put(push('/2fa/reset'))
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
  }
}

export function* verifyCodeResetSaga({ payload }) {
  try {
    const { code } = payload
    yield put(showOverlay())
    const data = yield call(verifyCodeReset, code)
    yield put({
      type: SUCCESS(VERIFY_CODE_RESET),
      payload: {
        qrCode: data.result.qrCode
      }
    })
    yield put(push('/2fa/choice', { qrCode: data.result.qrCode, verify: true }))
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
  }
}

export function* verifyCodeSaga({ payload }) {
  try {
    const { code } = payload
    yield put(showOverlay())
    const data = yield call(verifyCode, code)
    setLocalStorage(STORAGE.USER_TOKEN, data.result.token)
    setLocalStorage(STORAGE.FAEnabled, true)
    yield put({
      type: SUCCESS(VERIFY_CODE)
    })
    setLocalStorage(STORAGE.FAEnabled, true)
    yield put({
      type: SUCCESS(SET_IS_2FA)
    })
    yield put(hideOverlay())
    yield put(showModalMessage({ message: 'Verify', type: 'success' }))
  } catch (error) {
    yield put({
      type: FAILURE(VERIFY_CODE)
    })
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
  }
}

export function* generateCodeSaga() {
  try {
    yield put(showOverlay())
    const data = yield call(generateCode)
    yield put({
      type: SUCCESS(GENERATE_CODE),
      payload: {
        qrCode: data.result.qrCode
      }
    })
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
  }
}

export default function* authSaga() {
  yield takeLatest(REQUEST(RESET_2FA), reset2FASaga)
  yield takeLatest(REQUEST(VERIFY_CODE_RESET), verifyCodeResetSaga)
  yield takeLatest(REQUEST(VERIFY_CODE), verifyCodeSaga)
  yield takeLatest(REQUEST(GENERATE_CODE), generateCodeSaga)
}
